import { render, staticRenderFns } from "./SelectSection.vue?vue&type=template&id=1a55132e&"
import script from "./SelectSection.vue?vue&type=script&lang=js&"
export * from "./SelectSection.vue?vue&type=script&lang=js&"
import style0 from "./SelectSection.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports